module.exports = "/static/assets/f27bd3fc11913ac19cf04b4652c61315.png";